<template>
  <div class="overlay">
    <div data-vue-overlay class="overlay--carousel" aria-modal="true" role="dialog">
      <div class="overlay__content-container" data-overlay-content-container style="margin-top: 7.5rem;">
        <div class="overlay__content" data-overlay-image-content>
          <OverlayControlsUpper ref="overlayControlsUpper" :title="title" @close="close" />
          <div style="margin-bottom: 6rem; margin-top: -2rem; padding-bottom: 2rem;">
            <OverlayImage :altText="altText" ref="overlayImage" :imageSrc="imageSrc" :title="title" />
            <OverlayControlsLower ref="overlayControlsLower" :altText="altText" :imageCredit="imageCredit"
              :imageSrc="imageSrc" :currentIndex="carouselContext.index" :itemCount="carouselContext.itemCount"
              @next="$emit('next')" @previous="$emit('previous')" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import KeyCodes from "../../utils/key-codes.js";
import OverlayControlsUpper from "./controllers/overlay-controls-upper.vue";
import OverlayControlsLower from "./controllers/overlay-controls-lower.vue";
import OverlayImage from "./overlay-image.vue";
import TrapTab from "../../utils/tab-trapper.js";

export default {
  components: {
    OverlayControlsUpper,
    OverlayImage,
    OverlayControlsLower
  },
  props: {
    carouselContext: { type: Object, required: true },
    altText: { type: String, required: true },
    imageCredit: { type: String, required: true },
    imageSrc: { type: String, required: true },
    title: { type: String, required: false, default: '' }
  },

  mounted: function () {
    document.addEventListener('keydown', this.onKeyDown);

    this.$el.classList.add("overlay--opened");
    this.$emit('open');

    const onOpenTransitionEnd = (e) => {
      if (e.propertyName != 'opacity') return;
      this.$refs.overlayImage.$el.focus();
      this.$el.removeEventListener('transitionend', onOpenTransitionEnd);
    }
    this.$el.addEventListener('transitionend', onOpenTransitionEnd);
  },

  beforeDestroy() {
    document.removeEventListener('keydown', this.onKeyDown);
  },

  methods: {
    close: function (e) {
      e.preventDefault();

      this.$el.classList.remove("overlay--opened");
      this.$el.classList.remove("overlay--hide-controls");

      const onCloseTransitionRun = (e) => {
        if (e.propertyName != 'opacity') return;
        this.$el.removeEventListener('transitionrun', onCloseTransitionRun);
      }
      this.$el.addEventListener('transitionrun', onCloseTransitionRun);

      this.$emit('close', { triggerElImageSrcAttr: this.triggerElImageSrcAttr });
    },

    isOpen: function () {
      return this.$el.classList.contains("overlay--opened");
    },

    cycleTab: function (e) {
      if (this.$el.classList.contains("overlay--hide-controls")) {
        e.preventDefault();
        this.$el.classList.remove("overlay--hide-controls");
        this.$refs.overlayControlsUpper.$el.focus(); // Unsure it works
        return;
      }
      return TrapTab(this.$el, e);
    },

    onKeyDown(e) {
      switch (e.keyCode) {
        case KeyCodes.ESCAPE:
          return this.close(e);
        case KeyCodes.TAB:
          if (!this.isOpen()) return;
          return this.cycleTab(e);
      }
    }
  }
};
</script>
